import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { loadStripe } from '@stripe/stripe-js/pure';
export default function (_x, _x2) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(context, inject) {
    var parsedOptions, stripePlugin, publishableKey, stripeAccount, locale, apiVersion, runtimeConfig, options, _t;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          parsedOptions = {
            "stripeAccount": "",
            "locale": "en",
            "apiVersion": null
          };
          stripePlugin = null;
          _context.prev = 1;
          publishableKey = parsedOptions.publishableKey, stripeAccount = parsedOptions.stripeAccount, locale = parsedOptions.locale, apiVersion = parsedOptions.version;
          /**
           * Override the parsed options with the runtime config
           * as the runtime config always override.
           */
          runtimeConfig = context.$config.stripe;
          if (runtimeConfig) {
            if (runtimeConfig.publishableKey) publishableKey = runtimeConfig.publishableKey;
            if (runtimeConfig.stripeAccount) stripeAccount = runtimeConfig.stripeAccount;
            if (runtimeConfig.locale) locale = runtimeConfig.locale;
            if (runtimeConfig.version) apiVersion = runtimeConfig.version;
          }
          if (publishableKey) {
            _context.next = 2;
            break;
          }
          throw new Error('A Stripe publishable key is required.');
        case 2:
          options = {
            locale: locale,
            apiVersion: apiVersion
          };
          if (stripeAccount) options.stripeAccount = stripeAccount;
          _context.next = 3;
          return loadStripe(publishableKey, options);
        case 3:
          stripePlugin = _context.sent;
          _context.next = 5;
          break;
        case 4:
          _context.prev = 4;
          _t = _context["catch"](1);
          console.error("[nuxt-stripe-module] ".concat(_t.message));
        case 5:
          inject('stripe', stripePlugin);
          context.app.stripe = stripePlugin;
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _ref.apply(this, arguments);
}